/**
 * ModeSelector Component (Issue #302)
 *
 * The mode list shown inside ModeIndicator's dropdown.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '../ui/dropdown-menu';
import {
  ChatModeOptionContent,
  modeColorStyle,
  modeOptionClassName,
} from './ChatModeOption';
import { ChatMode } from '../../types/chat';

interface ModeSelectorProps {
  modes: ChatMode[];
  currentModeId: string;
  isSwitching: boolean;
  onSelect: (mode: ChatMode) => void;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({
  modes,
  currentModeId,
  isSwitching,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
        {t('chat.modeSelectorTitle')}
      </DropdownMenuLabel>
      <DropdownMenuSeparator />

      {/* gap, not just padding: adjacent rows' hover fills touched otherwise */}
      <div className="flex flex-col gap-0.5 p-1.5">
        {modes.map((mode) => {
          const isSelected = mode.id === currentModeId;

          return (
            <DropdownMenuItem
              key={mode.id}
              onSelect={() => onSelect(mode)}
              disabled={isSwitching}
              style={modeColorStyle(mode)}
              className={modeOptionClassName(isSelected)}
            >
              <ChatModeOptionContent mode={mode} selected={isSelected} busy={isSwitching} />
            </DropdownMenuItem>
          );
        })}
      </div>

      <DropdownMenuSeparator />
      <p className="bg-muted/50 px-2 py-1.5 text-center text-xs text-muted-foreground">
        {t('chat.modeSelectorHint')}
      </p>
    </>
  );
};

export default ModeSelector;
